export default (currentAccount => {
  return currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.services.map(_ref => {
    let {
      admin_category,
      account_url,
      display_name,
      project_url: serviceProjectUrl,
      service_access,
      service_category,
      service_domain,
      service_icon,
      service_type
    } = _ref;
    return {
      adminCategory: admin_category,
      accountUrl: account_url,
      displayName: display_name,
      projectUrl: serviceProjectUrl,
      serviceAccess: service_access,
      serviceCategory: service_category,
      serviceDomain: service_domain,
      serviceIcon: service_icon,
      serviceType: service_type
    };
  });
});
//# sourceMappingURL=getAccountServices.js.map